const config = {
  // backendUrl: "http://localhost:30001/",
  // backendUrl: "http://localhost:20001/",
  backendUrl: "https://rainbow.payfren.id/",
  PayFren: "https://payfren.id/",
  Resource: "https://resource.payfren.id/",
};
export default config;
